import React, {useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../framework.core/JobNames";
import {airExportQuotationList} from "../tableSettings";
import {AeQuoteListItem} from "../../../fms.data/models/AeQuoteListItem";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import * as XCol from '../../../framework.core/XExportColumn';
import { QuotationArgs } from '../../../fms.report/args';
import {DocumentType} from '../../../framework.core/DocumentType';
import useReportViewer from '../../../hooks/useReportViewer';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { FmsSecTask } from '../../../fms.core/constants';
import { findSecurityTask } from '../../../util';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, PrintIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// function MoveTypeFilterRenderer({value, onChange}: any) {
//   return (
//     <MoveTypeDropDown
//       value={value}
//       onChange={moveType => onChange(moveType)}
//     />
//   );
// }

// function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
//   return (
//     <div style={{height: '100%'}}>
//       <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
//         <CurrencyLabel currency={currency} value={value}/>
//       </div>
//     </div>
//   );
// }

// function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
//   const entity = data[row.index];

//   return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
//     <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
//             onClick={() => onLinkToAccounting(entity)}>{value}</button>
//     &nbsp;
//   </div>;
// }

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const sourceUrl = `${history.location.pathname}${history.location.search}`;
  // 250611.inhyung. OI Quotation List >> Detail 이동시 Operation이 OE로 이동하는 이슈 해결
  const operation = sourceUrl.includes('airImport') ? 'airImport' : 'airExport';

  const selectedElement = jobListContext.selectedElement as AeQuoteListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const { viewReport } = useReportViewer();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/quotation/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, `/${operation}/quotation/add`, NavigationType.newPage);
  }

  async function deleteQuotation() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/quotation/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/quotation/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Quotation first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.AEQuotation, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/${operation}/quotation/edit/${id}`;
    const viewUrl = `/${operation}/quotation/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/${operation}/quotation/edit`, editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/${operation}/quotation/edit/${id}`;
    const viewUrl = `/${operation}/quotation/view/${id}`;

    const listSec = findSecurityTask(appContext, (operation === constants.opTypes.airImport ? FmsSecTask.AIQuot : FmsSecTask.AEQuot));
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/quotation/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/${operation}/quotation/add?copyId=${id}`, NavigationType.newPage);
  }

  async function print() {
    const title = `Air Quotation ${selectedElement.quoteNo}`;
    const args = new QuotationArgs({
      docType: DocumentType.QuotationAir,
      formCaption: title,
      subject: title,

      quoteID: selectedElement.id,
      branch: appContext.user?.branch??'',
      toCompanyid: `${selectedElement.agentId}${String.fromCharCode(127)}${selectedElement.customerId}`,
      tbName: 'T_AOHQUOTATION',
      tbId: selectedElement.id?.toString()||'0',
    })
    viewReport(args, "", true);
  }

  return {create, deleteQuotation, edit, view, copy, print, operation};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteQuotation, edit, view, copy, operation } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AeQuoteListItem;
   const appContext = useContext(ApplicationContext);
  // const [showGlobalOkDialog] = useGlobalOkDialog();
  
  const listSec = findSecurityTask(appContext, (operation === constants.opTypes.airImport ? FmsSecTask.AIQuot : FmsSecTask.AEQuot));

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd  },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: true, hidden: !listSec?.grantAdd },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="airquotation-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteQuotation();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 6:
        copy();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);

  const selectedElement = jobListContext.selectedElement as AeQuoteListItem;

  const {deleteQuotation, edit, view, copy, print, operation} = useSelectedOperations();

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/quotation/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/quotation/view/${id}`);
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/quotation/add`);
  }

  const listSec = findSecurityTask(appContext, (operation === 'airImport' ? FmsSecTask.AIQuot : FmsSecTask.AEQuot));

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className="ifms-common-vertical-gap-8">
        <UniqueLinkButton newStyle name='airquotation-list-add-button' display="primary" link={`/${operation}/quotation/add`} disabled={!canBeAdd} label={<FontAwesomeIcon icon={faPlus}/>} useOnlyIcon data-tooltip='New' iconMode/>
        <EditIconButton2 name='airquotation-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='airquotation-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name='airquotation-list-delete-button' disabled={!canBeDeleted} onClick={deleteQuotation} useText/>
      </div>
      <div className="ifms-common-vertical-gap-8">
        <PrimaryButton name='airquotation-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
        <PrintIconButton data-tooltip='Print Quotation' name='airquotation-list-print-button' disabled={!hasSelectedRow} onClick={print} useText/>
      </div>
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);

  const {copy, create, edit, view, operation} = useSelectedOperations();
  const listSec = findSecurityTask(appContext, (operation === 'airImport' ? FmsSecTask.AIQuot : FmsSecTask.AEQuot));


  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
      create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F2', 'CTRL+F2', 'F3', 'F4', 'SHIFT+F4', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.oceanExportMbl}
      jobName={JobNames.AEQuotation}
      //entityId={(jobListContext.selectedElement as OeMblListItem | null)?.id}
      jobId={(jobListContext.selectedElement as AeQuoteListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

function AfterMemoLogButtonCommands() {
 return null;
}

/**
 * Concrete implementation for Quotation List screen
 *
 * @class QuotationListView
 * @extends {AbstractListView}
 */
class QuotationListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    // const searchParams = AeQuoteListItem.calculateSearchParameters(search, AeQuoteListItem.MapSearchFields);
    // searchParams['opType'] = opType === 'airImport' ? 'I' : 'E';

    // if (searchParams.searchField === undefined) {
    //   searchParams.searchField = ['opType']
    // } else {
    //   searchParams.searchField.push('opType');
    // }

    const apiResult = await api.getListItems(
      JobNames.AEQuotation,
      'AeQuoteListItem',
      AeQuoteListItem.calculateSearchParameters(search, AeQuoteListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: AeQuoteListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }


  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AEQuotation, 'AeQuoteListItem',
      AeQuoteListItem.calculateSearchParameters(search, AeQuoteListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  AeQuoteListItem.formatData(apiResult.entities);
  }
  



  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return AeQuoteListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.dataIndex === "status") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      // { accessor:'hblCount', Cell: HblRenderer, Header: () => <span><u>HBL</u>(s)</span> },
      else if(x.dataIndex === 'customer') {
        colRenderer.Cell = TextAlignLeftRenderer;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  airExportQuotationList;
    const cols = AeQuoteListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: AeQuoteListItem) {
    return row && row.id ? `/airExport/quotation/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'AE Quotation List';
  };

  hasRightClickContext(): boolean {
    return true;
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
}

export default QuotationListView;
